export const pt = {
  // Global
  lang_name: 'Portugu\u00eas',
  lang_code: 'pt',
  platform_name: 'Sovereign IQ',
  platform_subtitle: 'Plataforma de Intelig\u00eancia',
  confidential: 'Confidencial',
  loading: 'Carregando...',
  save: 'Salvar',
  cancel: 'Cancelar',
  delete: 'Excluir',
  search: 'Pesquisar',
  submit: 'Enviar',
  back: 'Voltar',
  next: 'Pr\u00f3ximo',
  close: 'Fechar',
  download: 'Baixar',
  export_csv: 'Exportar CSV',
  generating: 'Gerando...',
  generated: 'Gerado',
  not_generated: 'Ainda n\u00e3o gerado',
  success: 'Sucesso',
  error: 'Erro',

  // Navigation
  nav_home: 'Site Principal',
  nav_dashboard: 'Painel',
  nav_countries: 'Pa\u00edses',
  nav_configuration: 'Configura\u00e7\u00e3o',
  nav_generator: 'Gerador',
  nav_compare: 'Comparar',
  nav_documents: 'Documentos',
  nav_use_cases: 'Casos de Uso',
  nav_user_management: 'Gest\u00e3o de Usu\u00e1rios',
  nav_pricing_model: 'Modelo de Pre\u00e7os',
  nav_ai_budget: 'Or\u00e7amento IA',
  nav_collapse: 'Recolher',
  nav_logout: 'Sair',

  // Landing Page
  landing_hero_title: 'Intelig\u00eancia Soberana',
  landing_hero_subtitle: 'An\u00e1lise de risco-pa\u00eds e projetos de expans\u00e3o global de grau de investimento, impulsionados por IA',
  landing_cta: 'Comece Agora',
  landing_login: 'Entrar',
  landing_features_title: 'Capacidades da Plataforma',
  landing_doc: 'Documenta\u00e7\u00e3o',
  landing_use_cases: 'Casos de Uso',
  landing_sources: 'Fontes',
  landing_pricing: 'Pre\u00e7os',

  // Login/Register
  login_title: 'Entrar',
  login_subtitle: 'Acesse seu painel de intelig\u00eancia',
  login_email: 'Endere\u00e7o de Email',
  login_password: 'Senha',
  login_btn: 'Entrar',
  login_register_link: 'Criar uma conta',
  register_title: 'Registrar',
  register_subtitle: 'Junte-se \u00e0 plataforma Sovereign IQ',
  register_full_name: 'Nome Completo',
  register_company: 'Empresa',
  register_location: 'Localiza\u00e7\u00e3o (Cidade, Pa\u00eds)',
  register_areas: '\u00c1reas de Interesse',
  register_btn: 'Registrar',
  register_pending: 'Seu registro est\u00e1 aguardando aprova\u00e7\u00e3o.',
  register_login_link: 'J\u00e1 tem uma conta? Entre',

  // Dashboard
  dash_title: 'Painel de Intelig\u00eancia Pa\u00eds',
  dash_subtitle: 'Monitoramento em tempo real de riscos soberanos e intelig\u00eancia econ\u00f4mica',
  dash_intelligence_feed: 'Feed de Intelig\u00eancia',
  dash_key_targets: 'Alvos Principais',
  dash_system_status: 'Status do Sistema',
  dash_economic_forecasts: 'Previs\u00f5es Econ\u00f4micas FMI',
  dash_data_sources: 'Monitor de Fontes',
  dash_trend_chart: 'Tend\u00eancia Hist\u00f3rica',
  dash_world_map: 'Mapa Global de Riscos',

  // Countries
  countries_title: 'Alvos de Intelig\u00eancia',
  countries_subtitle: 'Seu portf\u00f3lio de intelig\u00eancia pa\u00eds',
  countries_add: 'Adicionar Territ\u00f3rio',
  countries_search: 'Pesquisar pa\u00edses...',
  countries_no_results: 'Nenhum pa\u00eds encontrado',
  countries_sections: 'se\u00e7\u00f5es',
  countries_remaining: 'Relat\u00f3rios Restantes',
  countries_pdf: 'Relat\u00f3rio PDF',
  countries_view: 'Ver Projeto',
  countries_delete_confirm: 'Excluir este pa\u00eds e todos os seus dados?',

  // Blueprint Config
  config_title: 'Configura\u00e7\u00e3o do Projeto',
  config_subtitle: 'Configure os par\u00e2metros do projeto de intelig\u00eancia pa\u00eds',
  config_country: 'Selecionar Pa\u00eds',
  config_sector: 'Selecionar Setor',
  config_focus: '\u00c1reas de Foco',
  config_generate: 'Gerar Projeto',

  // Generator
  gen_title: 'Gerador de Se\u00e7\u00f5es',
  gen_subtitle: 'Sintetizando fluxos de dados multimodais para avalia\u00e7\u00e3o regional de alta fidelidade.',
  gen_select_country: 'Selecionar pa\u00eds',
  gen_generate_all: 'Gerar Tudo (Texto + Ilustra\u00e7\u00f5es)',
  gen_generate: 'Gerar',
  gen_regenerate: 'Regenerar',
  gen_generate_illustration: 'Gerar Ilustra\u00e7\u00e3o',
  gen_regenerate_illustration: 'Regenerar Ilustra\u00e7\u00e3o',
  gen_preview: 'Pr\u00e9via',
  gen_complete: 'Completo',
  gen_draft: 'Rascunho',
  gen_illustrated: 'Ilustrado',
  gen_creating_illustration: 'Criando ilustra\u00e7\u00e3o...',
  gen_generating_synthesis: 'Gerando S\u00edntese...',
  gen_regenerations_used: 'regenera\u00e7\u00f5es usadas',
  gen_regional_intelligence: 'Intelig\u00eancia Regional',
  gen_updated: 'Atualizado',
  gen_outlook: 'Perspectivas',
  gen_additional_sections: 'Se\u00e7\u00f5es adicionais dispon\u00edveis',
  gen_select_prompt: 'Selecione um Pa\u00eds',
  gen_select_prompt_desc: 'Escolha um pa\u00eds no menu acima para come\u00e7ar a gerar se\u00e7\u00f5es.',

  // Blueprint View
  bp_sections_generated: 'Se\u00e7\u00f5es Geradas',
  bp_economic_trends: 'Tend\u00eancias Econ\u00f4micas',
  bp_world_bank_data: 'Dados do Banco Mundial',
  bp_ai_studio: 'Est\u00fadio IA',
  bp_quick_export: 'Exporta\u00e7\u00e3o R\u00e1pida',
  bp_pdf_report: 'Relat\u00f3rio PDF',
  bp_generate_audio: 'Gerar Vis\u00e3o Geral em \u00c1udio',
  bp_regenerate_audio: 'Regenerar \u00c1udio',
  bp_generate_infographic: 'Gerar Infogr\u00e1fico',
  bp_regenerate_infographic: 'Regenerar Infogr\u00e1fico',
  bp_generate_references: 'Gerar Refer\u00eancias',
  bp_regenerate_references: 'Regenerar Refer\u00eancias',
  bp_audio_overview: 'Vis\u00e3o Geral em \u00c1udio',
  bp_infographic: 'Infogr\u00e1fico de Investimento',
  bp_references: 'Fontes & Refer\u00eancias',

  // Section Names
  sec_country_snapshot: 'Indicadores Macroecon\u00f4micos',
  sec_executive_summary: 'Resumo Executivo',
  sec_pestle_analysis: 'Risco Geopol\u00edtico',
  sec_market_opportunity: 'Oportunidade de Mercado',
  sec_government_capacity: 'Capacidade Governamental',
  sec_competitive_landscape: 'Panorama Competitivo',
  sec_business_model: 'Modelo de Neg\u00f3cios',
  sec_risk_analysis: 'An\u00e1lise de Riscos',
  sec_financial_projections: 'Quadro Regulat\u00f3rio',
  sec_sovereign_risk: 'Risco Soberano',
  sec_social_impact: 'Capital Humano',
  sec_governance: 'Governan\u00e7a',

  // Admin
  admin_title: 'Gest\u00e3o de Usu\u00e1rios',
  admin_users: 'Usu\u00e1rios',
  admin_approve: 'Aprovar',
  admin_reject: 'Rejeitar',
  admin_pending: 'Pendente',
  admin_active: 'Ativo',
  admin_gift_reports: 'Relat\u00f3rios Presenteados',
  admin_email_config: 'Configura\u00e7\u00e3o de Email',
  admin_bcc_email: 'Email CCO',

  // Pricing
  pricing_title: 'Pre\u00e7os',
  pricing_per_report: 'Por Relat\u00f3rio',
  pricing_buy_report: 'Comprar Relat\u00f3rio',
  pricing_coupon: 'C\u00f3digo Promocional',
  pricing_redeem: 'Resgatar',
  pricing_lucky: 'Tente a Sorte',
  pricing_request_free: 'Solicitar Relat\u00f3rio Gratuito',

  // Budget
  budget_title: 'Monitor de Or\u00e7amento IA',
  budget_available: 'Saldo Dispon\u00edvel',
  budget_spent: 'Total Gasto',
  budget_generations: 'Total de Gera\u00e7\u00f5es',

  // Comparison
  compare_title: 'Compara\u00e7\u00e3o de Pa\u00edses',
  compare_subtitle: 'Compare indicadores econ\u00f4micos entre pa\u00edses',
  compare_select: 'Selecione os pa\u00edses para comparar',

  // Payment
  payment_success: 'Pagamento Realizado!',
  payment_report_added: 'Seu relat\u00f3rio foi adicionado \u00e0 sua conta.',
};
